import TextFieldWithLabel from "../Features/TextFieldWithLabel";
import DropdownWithLabel from "../Features/DropdownWithLabel";
import CheckBoxWithChildLabel from "../Features/CheckBoxWithChildLabel";
import {useState} from "react";

const FormAllen = (props) => {

    const [vehicleMake, setVehicleMake] = useState("");

    return <div>
      <div className={"columns-2"}>
          <TextFieldWithLabel fieldName={"firstName"} fieldLabel={"First Name"} register={props.register} errors={props.errors}></TextFieldWithLabel>
          <TextFieldWithLabel fieldName={"lastName"} fieldLabel={"Last Name"} register={props.register} errors={props.errors}></TextFieldWithLabel>
      </div>
      <TextFieldWithLabel fieldName={"emailAddress"} fieldLabel={"Email Address"} register={props.register} errors={props.errors} pattern={/^\S+@\S+$/}></TextFieldWithLabel>
      <TextFieldWithLabel fieldName={"address1"} fieldLabel={"Address"} register={props.register} errors={props.errors}></TextFieldWithLabel>
      <div className={"columns-3"}>
          <TextFieldWithLabel fieldName={"city"} fieldLabel={"City"} register={props.register} errors={props.errors}></TextFieldWithLabel>
          <DropdownWithLabel fieldName={"state"} fieldLabel={"State"} register={props.register} errors={props.errors}>
              <option value={""}>Choose one...</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
          </DropdownWithLabel>
          <TextFieldWithLabel fieldName={"zip"} fieldLabel={"ZIP"} register={props.register} errors={props.errors} pattern={/^\d{5}?$/}></TextFieldWithLabel>
      </div>

      <DropdownWithLabel fieldName={"cadillacBrandForMe"} fieldLabel={"Please rate the extent to which you agree with the following: 'Cadillac is a Brand For Me'"} register={props.register} errors={props.errors}>
          <option value={""}>Choose one...</option>
          <option value={"Strongly Agree"}>Strongly Agree</option>
          <option value={"Agree"}>Agree</option>
          <option value={"Neither Agree Disagree"}>Neither Agree nor Disagree</option>
          <option value={"Disagree"}>Disagree</option>
          <option value={"Strongly Disagree"}>Strongly Disagree</option>
      </DropdownWithLabel>

      <div className={"lg:columns-2"}>
        <DropdownWithLabel fieldName={"vehicleMake"} fieldLabel={"What is the primary vehicle in your household? "} register={props.register} errors={props.errors} onChange={setVehicleMake}>
          <option value={""}>[Make] Choose one...</option>
          <optgroup label={"GM Brands"}>
              <option value={"Chevrolet"}>Chevrolet</option>
              <option value={"Buick"}>Buick</option>
              <option value={"GMC"}>GMC</option>
              <option value={"Cadillac"}>Cadillac</option>
          </optgroup>
          <optgroup label={"Other Brands"}>
              <option value={"Acura"}>Acura</option>
              <option value={"Alfa Romeo"}>Alfa Romeo</option>
              <option value={"Audi"}>Audi</option>
              <option value={"Bentley"}>Bentley</option>
              <option value={"BMW"}>BMW</option>
              <option value={"Chrysler"}>Chrysler</option>
              <option value={"Daimler"}>Daimler</option>
              <option value={"Dodge"}>Dodge</option>
              <option value={"Fiat"}>Fiat</option>
              <option value={"Ford"}>Ford</option>
              <option value={"Genesis"}>Genesis</option>
              <option value={"Honda"}>Honda</option>
              <option value={"Hyundai"}>Hyundai</option>
              <option value={"Infiniti"}>Infiniti</option>
              <option value={"Jaguar"}>Jaguar</option>
              <option value={"Jeep"}>Jeep</option>
              <option value={"Kia"}>Kia</option>
              <option value={"Land Rover"}>Land Rover</option>
              <option value={"Lexus"}>Lexus</option>
              <option value={"Lincoln"}>Lincoln</option>
              <option value={"Lotus"}>Lotus</option>
              <option value={"Lucid"}>Lucid</option>
              <option value={"Maserati"}>Maserati</option>
              <option value={"Mazda"}>Mazda</option>
              <option value={"Mercedes"}>Mercedes</option>
              <option value={"Mini Cooper"}>Mini Cooper</option>
              <option value={"Mitsubishi"}>Mitsubishi</option>
              <option value={"Nissan"}>Nissan</option>
              <option value={"Polestar"}>Polestar</option>
              <option value={"Porsche"}>Porsche</option>
              <option value={"RAM"}>RAM</option>
              <option value={"Rivian"}>Rivian</option>
              <option value={"Rolls-Royce"}>Rolls-Royce</option>
              <option value={"Subaru"}>Subaru</option>
              <option value={"Smart"}>Smart</option>
              <option value={"Tesla"}>Tesla</option>
              <option value={"Toyota"}>Toyota</option>
              <option value={"Volkswagen"}>Volkswagen</option>
              <option value={"Volvo"}>Volvo</option>
          </optgroup>
          <option value={"NoVehicle"}>I don’t currently own or lease a vehicle</option>
        </DropdownWithLabel>

        <DropdownWithLabel fieldName={"householdVehicle"} fieldLabel={" "} register={props.register} errors={props.errors} disabled={vehicleMake === "NoVehicle"} required={vehicleMake !== "NoVehicle"}>
            {vehicleMake === "NoVehicle" ?
                <option value={"N/A"}>N/A - No Vehicle</option>
            : <>
                <option value={""}>[Type] Choose one...</option>
                <option value={"Car"}>Car</option>
                <option value={"SUV"}>Crossover & SUV</option>
                <option value={"Truck"}>Pickup Truck</option>
                <option value={"Van"}>Van</option>
                <option value={"Electric Vehicle"}>Electric Vehicle</option>
            </>}
        </DropdownWithLabel>
      </div>

      <CheckBoxWithChildLabel fieldName={"terms"} register={props.register} errors={props.errors} preChecked={false}>
          I agree to PGA of America's Privacy Policy and Terms of Service.
      </CheckBoxWithChildLabel>

      <CheckBoxWithChildLabel fieldName={"communications"} register={props.register} errors={props.errors} required={false} preChecked={true}>
          By checking this box, you are subscribing to PGA of America Communications
      </CheckBoxWithChildLabel>
    </div>
}

export default FormAllen;
